export enum ErrorCategory {
  Unknown = 'unknown',
  AccessDenied = 'accessDenied',
  NotFound = 'notFound',
  ExpiredLink = 'expiredLink',
}
